<template>
  <el-container class="gt-app page-container gt-layout" v-if="!isYFJ">
    <el-header height="48px">
      <gt-header></gt-header>
    </el-header>
    <el-container class="gt-layout__main" :key="pageKey">
      <gt-menu></gt-menu>
      <el-main :class="[$route.name]" class="gt-layout__content">
        <transition name="fade-transform" mode="out-in">
          <div class="gt-layout__content-inner">
            <router-view></router-view>
            <div class="gt-layout__qiankun-app-container"></div>
          </div>
        </transition>
      </el-main>
    </el-container>
  </el-container>

  <el-container class="gt-app page-container gt-layout gt-layout-update" v-else>
    <el-aside width="92px">
      <MenuCom></MenuCom>
    </el-aside>
    <el-container class="gt-layout__main" :key="pageKey">
      <el-header height="56px">
        <HeaderCom></HeaderCom>
      </el-header>
      <el-main
        id="scrollMain"
        :class="[$route.name || activeRoute.name]"
        class="gt-layout__content"
      >
        <transition name="fade-transform" mode="out-in">
          <div class="gt-layout__content-inner">
            <router-view></router-view>
            <div class="gt-layout__qiankun-app-container"></div>
          </div>
        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { Component, Vue, Provide } from "vue-property-decorator";
import { namespace } from "vuex-class";
import gtMenu from "./children/Menu.vue";
import gtHeader from "./children/Header.vue";
import { start as qiankunMainApplicationStart } from "qiankun";

import MenuCom from "./components/Menu.vue";
import HeaderCom from "./components/Header.vue";

// 项目初始化 firstInit
const removeLocalstorge = keys =>
  keys.forEach(key => localStorage.removeItem(key));

const setLocalstorge = query =>
  Object.keys(query).forEach(key => {
    localStorage.setItem(key, query[key]);
  });

const Root = namespace("root");
@Component({
  components: { gtHeader, gtMenu, MenuCom, HeaderCom }
})
export default class App extends Vue {
  @Root.Action queryResourceListByRole;
  @Root.Action queryDistrict;
  @Root.Action getLanguages;
  @Root.State languageList;
  @Root.State activeRoute;
  @Root.Action appInit;

  pageKey = new Date().getTime();

  isYFJ = false;

  // isReload: boolean = true;

  @Provide("reload")
  reload() {
    // this.isReload = false;
    // this.$nextTick(() => {
    //   this.isReload = true;
    // });
    this.updatePageKey();
  }

  // 租户默认的国家
  async getAuthCountryAJAX() {
    try {
      let [{ label = "", value = "" }] = (await this.queryDistrict("root")) || [
        {}
      ];

      setLocalstorge({
        COUNTRY_INFO: JSON.stringify({ label, value }),
        COUNTRY_CODE: value,
        COUNTRY_LABEL: label
      });
    } catch (err) {
      console.log(err);
    }
  }

  async pageInit() {
    await this.appInit({
      permission: null,
      portal: { valueCode: "PORTAL_SYSTEM_DATA" },
      currency: { valueCode: "CURRENCY_TYPE" }
    });
    await this.queryResourceListByRole(null);
    this.getAuthCountryAJAX();
    await this.getLanguages();
    let locale = this.languageList[0] ? this.languageList[0].value : "";
    localStorage.setItem("localeLanguage", locale);
    localStorage.setItem("Language", locale);
  }

  async created() {
    let appCode = window.__GTECH_VARIABLES_APP_CODE__;
    // if (["K-ONE", "WIN-TOGETHER-TBR"].includes(appCode)) {
    //   this.isYFJ = true;
    // }
    this.isYFJ = true;
    await this.pageInit();
  }

  mounted() {
    // Qiankun main application needed only.
    if (
      !window.qiankunStarted &&
      process.env.VUE_APP_QIANKUN_APPLICATION_TYPE === "MAIN"
    ) {
      window.qiankunStarted = true;
      qiankunMainApplicationStart();
    }
  }
}
</script>

<style lang="scss">
.gt-app {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 100%;
  .gt-layout__main {
    height: calc(100% - 48px);
  }
  .el-header {
    padding: 0 !important;
  }

  &__outer {
    border-right: 1px solid $--color--split-line !important;
    position: relative;
    height: 100%;
    padding: 8px;
    padding-bottom: 50px;
    li {
      &.el-menu-item {
        width: 100%;
        line-height: 40px;
      }
    }

    &:not(.el-menu--collapse) {
      width: 240px;
      min-height: 400px;
    }
  }

  &__body {
    // margin-left: 240px;
    padding: 0 10px 10px 10px;
    background-color: #f4f5f5;
    height: 100%;
    overflow-y: scroll;
  }
  .gt-layout__content {
    padding: 0;
    height: 100%;
    overflow-y: auto;
    overflow-x: auto;
    background: #f4f7fa;
    position: relative;

    > .gt-layout__content-inner {
      padding: 0 24px 0px 24px;
      width: 100%;
      margin-bottom: 58px;
      min-width: 1000px;
    }

    /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    /*定义滚动条轨道 内阴影+圆角*/
    &::-webkit-scrollbar-track {
      // box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: #f5f5f5;
    }

    /*定义滑块 内阴影+圆角*/
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #555;
    }
  }
}
.gt-layout-update {
  &.gt-layout {
    flex-direction: row !important;
    .gt-layout__main {
      height: 100%;
    }
    .gt-layout__content {
      background-color: $bg;
    }
  }
}
</style>
